module.exports = __webpack_public_path__ + "img/cooperate_39.2186d55d.png";